import React from 'react';

const Email = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path
        d="M3.92897 3.62866H24.0765C25.451 3.62866 26.5779 4.72646 26.5953 6.07176L14.0071 12.9817L1.4218 6.0805C1.43345 4.72937 2.55163 3.62866 3.92897 3.62866ZM1.4218 8.72452L1.41016 20.9429C1.41016 22.3028 2.54289 23.4151 3.92897 23.4151H24.0765C25.4626 23.4151 26.5953 22.3028 26.5953 20.9429V8.7187L14.3041 15.3055C14.1149 15.4074 13.8877 15.4074 13.7014 15.3055L1.4218 8.72452Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Email;
